import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "view-header header-bar-surface" }
const _hoisted_2 = { class: "lottery-info" }
const _hoisted_3 = { class: "flag-container" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "lottery-details" }
const _hoisted_6 = { class: "lottery-name" }
const _hoisted_7 = { class: "countdown-section" }
const _hoisted_8 = { class: "countdown" }
const _hoisted_9 = { class: "time-block" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "time-block" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "time-block" }
const _hoisted_16 = { class: "time" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "action-section" }


import { getGameLogoUrl } from '../../utils/resultParser';


const __default__ = {
  name: "DesktopHeader",
};

interface Lottery {
  game_name?: string;
  country?: string;
  game_logo?: string;
  draw_date?: string;
  cutoff?: string;
}

interface Props {
  lottery: Lottery | null;
  countdown: {
    hours: number;
    minutes: number;
    seconds: number;
  };
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    lottery: {},
    countdown: {}
  },
  emits: ["go-back"],
  setup(__props: any) {






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.lottery?.game_logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(getGameLogoUrl)(_ctx.lottery.game_logo),
              alt: _ctx.lottery.country + ' flag',
              class: "flag"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.lottery?.game_name || 'Loading...'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(String(_ctx.countdown.hours).padStart(2, '0')), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('time.hours')), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(String(_ctx.countdown.minutes).padStart(2, '0')), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('time.mins')), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(String(_ctx.countdown.seconds).padStart(2, '0')), 1),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('time.secs')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('go-back')))
      }, " BACK TO LOTTERIES ")
    ])
  ]))
}
}

})